module.exports = __webpack_public_path__ + "img/outinmalibu_back.fbc4bac7.jpg";